var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    fill: "#23262F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 7.5,
    stroke: "#23262F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 11.7647C25.3375 12.0735 24.6233 12.2765 23.8834 12.3735C24.6405 11.9059 25.2256 11.1647 25.501 10.2735C24.7868 10.7147 23.9952 11.0235 23.1606 11.2C22.4809 10.4412 21.5258 10 20.4417 10C18.4197 10 16.7677 11.6941 16.7677 13.7853C16.7677 14.0853 16.8021 14.3765 16.8623 14.65C13.7992 14.4912 11.0717 12.9824 9.25621 10.6971C8.93786 11.2529 8.75717 11.9059 8.75717 12.5941C8.75717 13.9088 9.40249 15.0735 10.4006 15.7353C9.78967 15.7353 9.2218 15.5588 8.72275 15.2941V15.3206C8.72275 17.1559 9.99618 18.6912 11.6826 19.0353C11.1412 19.1872 10.5727 19.2084 10.022 19.0971C10.2557 19.8492 10.7134 20.5074 11.3307 20.9791C11.948 21.4507 12.694 21.7121 13.4637 21.7265C12.159 22.7857 10.5417 23.3582 8.87763 23.35C8.58509 23.35 8.29254 23.3324 8 23.2971C9.6348 24.3735 11.5793 25 13.6616 25C20.4417 25 24.1673 19.2294 24.1673 14.2265C24.1673 14.0588 24.1673 13.9 24.1587 13.7324C24.8815 13.2029 25.501 12.5324 26 11.7647Z",
    fill: "#B1B5C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.147c6a3e8e4ec0c4770c333d175c3165.svg";
export { ForwardRef as ReactComponent };